import type { VictoryThemeDefinition } from 'victory';

interface EikaChartPalette {
    chartInvested: string;
    chartInvestedLight: string;
    chartProfit: string;
    chartSavingsAccount: string;
    chartSavingsAccountLight: string;
    typography: string;
    typographySecondary: string;
    lightGrey: string;
}

const eikaChartPalette: EikaChartPalette = {
    chartInvested: 'var(--apple-green-dark-40)',
    chartInvestedLight: 'var(--apple-green-dark-20)',
    chartProfit: 'var(--typography-color)',
    chartSavingsAccount: 'var(--purple-dark)',
    chartSavingsAccountLight: 'var(--purple-dark-20)',
    typography: 'var(--typography-color)',
    typographySecondary: 'var(--typography-color-secondary)',
    lightGrey: 'var(--card-background-dark)',
};

const tickLabelStyle = {
    fontSize: 14,
    fontWeight: 400,
    fontFamily: 'Open Sans',
    fill: eikaChartPalette.typographySecondary,
    padding: 15,
};

export const EikaChartTheme: VictoryThemeDefinition & {
    eikaPalette: typeof eikaChartPalette;
} = {
    eikaPalette: eikaChartPalette,
    chart: {
        padding: { top: 16, right: 16, bottom: 40, left: 100 },
    },
    stack: {
        colorScale: [eikaChartPalette.typography, eikaChartPalette.chartInvested],
    },
    line: {
        style: {
            data: {
                stroke: eikaChartPalette.chartSavingsAccount,
                strokeWidth: 4,
            },
        },
    },
    independentAxis: {
        style: {
            axis: { stroke: 'transparent' },
            grid: { stroke: 'transparent' },
            tickLabels: tickLabelStyle,
        },
    },
    axis: {
        style: {
            axis: { stroke: 'transparent' },
            grid: { stroke: eikaChartPalette.lightGrey, strokeWidth: 1 },
            tickLabels: tickLabelStyle,
        },
    },
    legend: {
        style: {
            labels: {
                fontSize: 18,
            },
        },
    },
};
